module.exports = __webpack_public_path__ + "img/card-i8.b4d33b95.png";